"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxUser = void 0;
const toccata_1 = require("@musicaudienceexchange/toccata");
class MaxUser extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsNumber()
], MaxUser.prototype, "id", void 0);
__decorate([
    toccata_1.validator.IsString()
], MaxUser.prototype, "email", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], MaxUser.prototype, "photo", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], MaxUser.prototype, "displayName", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], MaxUser.prototype, "display_title", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], MaxUser.prototype, "group_display_name", void 0);
exports.MaxUser = MaxUser;
//# sourceMappingURL=auth.js.map